import cn from 'classnames'

export const localContainerClassName = cn(
   'flex items-center',
   'grow-0 text-left tracking-normal'
)
